// extracted by mini-css-extract-plugin
module.exports = {"section":"section_section__3chSe","title":"section_title__2nZLW"};